import { create } from 'zustand';

let nextId = 1;

export const useToast = create((set, get) => ({
  toasts: [],
  add: ({ type = 'info', message, ttl = 4000 }) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, type, message }] }));
    if (ttl > 0) {
      setTimeout(() => get().remove(id), ttl);
    }
    return id;
  },
  remove: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
}));

export const toast = {
  success: (message, ttl) => useToast.getState().add({ type: 'success', message, ttl }),
  error: (message, ttl) => useToast.getState().add({ type: 'error', message, ttl }),
  warning: (message, ttl) => useToast.getState().add({ type: 'warning', message, ttl }),
  info: (message, ttl) => useToast.getState().add({ type: 'info', message, ttl })
};
